import { render } from "./GameItem.vue?vue&type=template&id=aa42552a&scoped=true"
import script from "./GameItem.vue?vue&type=script&lang=js"
export * from "./GameItem.vue?vue&type=script&lang=js"

import "./GameItem.vue?vue&type=style&index=0&id=aa42552a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa42552a"]])

export default __exports__